import React, { useState } from "react";
import { Box, Button, Paper, Stack, Text, Title, Flex } from "@mantine/core";
import { McInputNew } from "../../../../components";

const CreateAccount: React.FC<{ onCreateAccount: (name: string, phoneNumber: string, password: string) => void }> = ({
  onCreateAccount,
}) => {
  const [name, setName] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [newPasswordAgain, setNewPasswordAgain] = useState<string>("");
  const [passwordDontmatch, setPasswordDontMatch] = useState<boolean>(false);

  const createAccount = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const doPasswordsMatch = newPassword === newPasswordAgain;

    setPasswordDontMatch(!doPasswordsMatch);

    if (doPasswordsMatch === true) {
      onCreateAccount(name, phoneNumber, newPassword);
    }
  };

  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Opprett konto
        </Title>
        <form style={{ width: "100%" }} onSubmit={(e) => createAccount(e)}>
          <Box mb="1rem">
            <McInputNew
              required
              minLength={2}
              type="text"
              placeholder="Skriv inn navnet ditt"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Box>
          <Box mb="1rem">
            <McInputNew
              required
              minLength={8}
              type="text"
              placeholder="Skriv inn telefonnummeret ditt"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </Box>
          <Box mb="1rem">
            <McInputNew
              required
              minLength={8}
              type="password"
              placeholder="Velg et passord"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </Box>
          <Box mb="1rem">
            <McInputNew
              required
              minLength={8}
              type="password"
              placeholder="Passord (igjen)"
              value={newPasswordAgain}
              onChange={(e) => setNewPasswordAgain(e.target.value)}
            />
          </Box>
          {passwordDontmatch === true && <Text c="red">Passordene er ikke like. Prøv igjen.</Text>}
          <Flex>
            <Box flex={1} />
            <Button type="submit">Opprett konto</Button>
            <Box flex={1} />
          </Flex>
        </form>
      </Stack>
    </Paper>
  );
};

export default CreateAccount;
